
const errorRefreshStepConfig = {
    component: () => import('./ErrorRefresh'),
    hideCartLink: true,
    hidePromoBanner: true
};

export default errorRefreshStepConfig;
